<template>
  <div v-if="value != null" class="profile-info-item">
    <p class="label">{{ label }}:</p>
    <p class="value">{{ value }}</p>
  </div>
</template>

<script>
export default {
  name: "ProfileInfoItem",
  props: {
    label: String,
    value: null,
  },
};
</script>

<style lang="scss" scoped>
.profile-info-item {
  border-bottom: #b1b1b1 1px solid;

  &:last-child {
    border-bottom: 0px;
  }
}

.label {
  font-weight: bold;
}
.value {
  // margin-left: 3rem;
  text-align: left;

}
</style>